import { CardContent, Typography, Button, Card as MuiCard, IconButton, Box } from "@material-ui/core";
import useStyles from "../../../assets/styles/styles";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import RoomIcon from "@material-ui/icons/Room";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import FaceIcon from "@material-ui/icons/Face";
import AddIcon from "@material-ui/icons/Add";
import { formatRawPhoneNumber, getPrestadorLocationLines } from "../../../utils/utilsFunctions";
import CustomButton from "../../../controls/Button/CustomButton";


const MedicalCardExternal = ({ item, i, handleClick, showMapsExternal, mapContainer, currentPosition }) => {
    const classes = useStyles();

    return (
        <>
            <MuiCard key={i} className={`${classes.card} ${classes.widthMedicalCard} ${classes.medicalCards} ${classes.medicalMuiCardStyles}`}>
                <CardContent className={classes.cardContentMuiCard}>
                    <Box className={classes.divCardContentMedicalCard}>
                        <Box className={classes.medicalCardCenterSection}>
                            <Box className={classes.medicalCardSuppliersStyles}>
                                {
                                    item?.clasificacionPrestador === "CENTRO MEDICO" ? (
                                        <LocationCityIcon className={classes.LocationCityIcon} />
                                    ) : (
                                        <FaceIcon className={classes.LocationCityIcon} />
                                    )
                                }
                            </Box>
                            <Box className={`${classes.divTitleMedicalCardExternal} ${classes.providerCompanyNameStyles}`}>
                                <Typography className={classes.descriptionCardSuppliers}> {item?.prestadorRazonSocial} </Typography>
                            </Box>
                            <Box className={classes.medicalCardButtonContainerStyles}>
                                <Typography style={{ padding: '0px', alignSelf: 'flex-start' }} component={Button} onClick={handleClick(item, i)}>
                                    <ChevronRightIcon className={classes.showMoreArrowIconCardSuppliers} />
                                </Typography>
                            </Box>
                        </Box>
                        <Box className={classes.cartillaPhonesSection}>
                            <Box className={classes.txtDescriptionPhone}>
                                <a href={`tel:${item?.telefono[0]?.telefonoNumero}`} className={`${classes.txtLinksInCard} ${classes.txtDescription} ${classes.txtEllipsis}`}>

                                    {formatRawPhoneNumber(item?.telefono[0]?.telefonoNumero?.trim())}

                                </a>
                                {
                                    item?.telefono?.length > 1 &&
                                    (
                                        <AddIcon className={`${classes.txtLinksInCard} ${classes.cartillaAddIconStyles}`} onClick={handleClick(item, i)}></AddIcon>
                                    )
                                }
                            </Box>
                            <Box className={ classes.cartillaPrestadorDomicilioContainer }>
                                <Box>
                                    <Typography className={classes.cartillaAddressStyles}>
                                        {item?.prestadorDomicilio}
                                    </Typography>
                                    {getPrestadorLocationLines(item).map((line, index) => (
                                        <Typography
                                            key={index}
                                            className={classes.cartillaAddressStyles}
                                        >
                                            {line}
                                        </Typography>
                                    ))}
                                </Box>

                                <Box>
                                    {mapContainer ?
                                        <a
                                            target="_blank"
                                            style={{ textDecoration: "none" }}
                                            href={
                                                "https://www.google.com/maps/dir/?api=1&origin=" +
                                                currentPosition?.lat +
                                                "%2C" +
                                                currentPosition?.lng +
                                                "&destination=" +
                                                item?.prestadorLatitud +
                                                "%2C" +
                                                item?.prestadorLongitud +
                                                "&travelmode=driving"
                                            }
                                        >
                                            <CustomButton
                                                title={"como llegar"}
                                                customClass={`${classes.customBtnMaps} ${classes.darkLinearGradient}`}
                                            />
                                        </a>
                                     : 
                                        <IconButton onClick={showMapsExternal(item, i)} >
                                            <RoomIcon className={classes.cartillaRoomIconStyles} />
                                        </IconButton>
                                    }
                                </Box>
                            </Box>
                            {item?.mail[0]?.mailDireccion?.trimEnd() !== '' &&
                                <Box className={classes.txtDescriptionMailDireccion}>
                                    <a href={`mailto:${item?.mail[0]?.mailDireccion}`} className={`${classes.txtLinksInCard} ${classes.txtDescription} ${classes.txtEllipsis}`}>
                                        {item?.mail[0]?.mailDireccion?.trimEnd()}
                                    </a>
                                    <AddIcon className={`${classes.txtDescriptionIconMailDireccion} ${classes.txtLinksInCard}`} onClick={handleClick(item, i)}></AddIcon>
                                </Box>
                            }
                            <Box className={ classes.cartillaObservacionStyles }>
                                <Typography className={`${classes.txtDescription}`}>
                                    {item?.observacion}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </CardContent>
            </MuiCard>
        </>
    );
};

export default MedicalCardExternal;